import React from 'react';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  componentDidCatch(error, info) {
    try { console.error('KY13 UI error:', error, info); } catch(e) {}
  }
  render() {
    if (this.state.error) {
      return (
        <div style={{padding: 24, fontFamily: 'Arial, sans-serif', minHeight: '100vh', display: 'grid', placeItems: 'center', background: '#fff'}}>
          <div style={{maxWidth: 460, textAlign: 'center'}}>
            <h2 style={{color:'#8f1321'}}>Mercadito KY-13</h2>
            <p>La tienda tuvo un problema cargando en este navegador.</p>
            <button onClick={() => window.location.reload()} style={{background:'#8f1321', color:'#fff', border:0, borderRadius:12, padding:'12px 18px', fontWeight:800}}>Recargar</button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
